<template>
  <footer>
    <!-- <div class="wrapper">
      <div class="footer_logo">
        <ul>
          <li class="logo_01"></li>
          <li class="logo_02"></li>
          <li class="logo_03"></li>
          <li class="logo_04"></li>
          <li class="logo_05"></li>
          <li class="logo_06"></li>
          <li class="logo_07"></li>
          <li class="logo_08"></li>
          <li class="logo_09"></li>
          <li class="logo_10"></li>
          <li class="logo_11"></li>
          <li class="logo_12"></li>
          <li class="logo_13"></li>
          <li class="logo_14"></li>
          <li class="logo_15"></li>
          <li class="logo_16"></li>
          <li class="logo_17"></li>
          <li class="logo_18"></li>
          <li class="logo_19"></li>
          <li class="logo_20"></li>
          <li class="logo_21"></li>
          <li class="logo_22"></li>
          <li class="logo_23"></li>
          <li class="logo_24"></li>
          <li class="logo_25"></li>
          <li class="logo_26"></li>
          <li class="logo_27"></li>
          <li class="logo_28"></li>
          <li class="logo_29"></li>
          <li class="logo_30"></li>
          <li class="logo_31"></li>
          <li class="logo_32"></li>
          <li class="logo_33"></li>
          <li class="logo_34"></li>
        </ul>
      </div>
      <div class="nav-bottom">
        <div class="footerInfo">
          <div class="footerl">
            <a class="flogo" @click="goPageByName('main')">
              <span class="copyright">Copyright 2026 DAISY. All Rights Reserved.</span>
            </a>
          </div>
        </div>
      </div>
    </div> -->
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState([
      'siteOption'
    ])
  }
}
</script>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/common.css"></style>
